import { isTypeNavigationCardsSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulNavigationCard from './ContentfulNavigationCard';
import ContentfulLargeCta from './ContentfulLargeCta';
import Divider from './util/Divider';
import MarkdownText from './util/MarkdownText';
import { getFullWidthBackgroundStyles } from './util/utils';
import cx from 'classix';

const ContentfulNavigationCardsSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationCardsSection(entry)) {
    return null;
  }

  return (
    <div className={getFullWidthBackgroundStyles(entry)}>
      <div className='sm:max-w-[600px] sm:mx-auto my-6 sm:my-12 text-center'>
        <h1 className='mx-auto max-w-3xl w-full font-header font-bold text-4xl sm:text-5xl text-gray-500 my-3'>
          {entry.fields.header}
        </h1>
        <h2 className='mx-auto max-w-3xl w-full font-header font-medium text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-400'>
          {entry.fields.subHeader}
        </h2>
        <Divider className='mx-auto' />
        <div className='max-w-[600px] mx-auto text-left'>
          <MarkdownText text={entry.fields.description} />
        </div>
      </div>
      <div
        className={cx(
          'max-w-full w-full py-8 flex flex-col',
          entry.fields.navigationCards.length > 4 && 'sm:grid sm:grid-cols-3',
          entry.fields.navigationCards.length <= 4 && 'sm:grid sm:auto-cols-auto sm:grid-flow-col',
          'gap-8 sm:gap-4 mx-auto',
        )}
      >
        {entry.fields.navigationCards?.map((card, index) => (
          <ContentfulNavigationCard key={index} entry={card} />
        ))}
      </div>
      <ContentfulLargeCta entry={entry.fields.cta} />
    </div>
  );
};

export default ContentfulNavigationCardsSection;
